import { useSyncExternalStore } from "react";
import {
  closeDockedChat,
  type DockedChat,
  getDockedChat,
  setDockedChatDraft,
  setDockedChatMinimised,
  setDockedChatSeenMessageId,
  subscribeToDockedChat,
} from "@/lib/message-dock-store";

interface UseMessageDockResult {
  chat: DockedChat | null;
  close: () => void;
  setDraft: (draft: string) => void;
  setMinimised: (minimised: boolean) => void;
  setSeenMessageId: (id: number | null) => void;
}

/** The open docked chat plus its controls. */
export function useMessageDock(): UseMessageDockResult {
  const chat = useSyncExternalStore(subscribeToDockedChat, getDockedChat, getDockedChat);

  return {
    chat,
    close: closeDockedChat,
    setDraft: setDockedChatDraft,
    setMinimised: setDockedChatMinimised,
    setSeenMessageId: setDockedChatSeenMessageId,
  };
}
